<template>
     <!-- Experience Modal -->
  <v-dialog v-model="modalDialog" max-width="625px">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Goal Rating</h5>
        <button type="button" class="close" @click="method(true)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="postKPIRating">
          <div>
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">
                  {{ Type == 0 ? "Rate your staff on the required measure of this goal" : (Type == 2) ? "Rate your colleague on the required measure of this goal" : "Rate yourself on the required measurement of this goal"}}
                </h3>
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="KPIRatings.length > 0">
                <div class="row" v-if="!complete">
                  <div class="col-md-7" style="padding-left: 1.75rem">
                      <span>{{item.goalMeasurement.measurement.kpi.title}}</span>
                  </div>
                  <div class="col-md-5">
                        <star-rating v-model="rating" :star-size="30" :show-rating="false" :active-on-click="true" @rating-selected="setRating" :clearable="true" />
                  </div>
                </div>
                <span v-if="complete"> Thank you for your answer, Kindly click on 'Done' to submit your response </span>
                </div>
                <span v-else> No rating available </span>
              </div>
            </div>
          </div>
          <div class="submit-section" v-if="KPIRatings.length == (viewSkill + 1)">
            <button class="btn btn-primary submit-btn" type="submit">
              Done
            </button>
          </div>
        </form>
      </div>
    </div>
  </v-dialog>
  <!-- /Experience Modal -->
</template>
<script>
import { required, sameAs } from "vuelidate/lib/validators";
import { performanceService } from "@/services/performanceService";
import Datepicker from "vuejs-datepicker";
import StarRating from 'vue-star-rating';
export default {
  props: {
    type: 0,
    id: 0,
    dialog: Boolean,
    method: { type: Function },
  },

  components: {
    Datepicker,
    StarRating
  },

  data() {
    return {
      modalDialog: this.dialog,
      goalId: this.id,
      Type: this.type,
      KPIRatings: [],
      item: {
        goalMeasurement: {
          measurement: {
            kpi: {}
          }
        }
      },
      rating: 0,
      viewSkill: 0,
      complete: false,
      error: "",
      message: "",
      submitted: false,
    };
  },

  mounted() {
    this.getKPIRating();
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  methods: {
    setRating() {
      var m = this.item
        if(this.rating > 0){
          console.log(this.rating)
       if(this.Type == 0){
         m.managerRating = this.rating
       }
       else if(this.Type == 2){
         m.otherRating = this.rating
       }else{
         m.employeeRating = this.rating
       }
       setTimeout(() => {
       var index = this.KPIRatings.findIndex(a => a.id == m.id);
       this.KPIRatings[index] = m;
       if(index + 1 < this.KPIRatings.length){
          this.rating = 0
          this.viewSkill = this.viewSkill + 1;
          this.item = this.KPIRatings[this.viewSkill]
          console.log(this.rating)
       }else{
            this.rating = 0
           this.complete = true;
       }
       }, 1000);
      }
    },
    postKPIRating() {
        performanceService
          .updateKPIRatings(this.KPIRatings
          )
          .then(
            (model) => {
              this.method(true);
              },
            (error) => {
              this.error = error;
            }
          );
      
    },
    getKPIRating() {
        performanceService
          .getKPIRatingsByGoal(this.goalId
          )
          .then(
            (model) => {
              this.KPIRatings = model.filter(c=> (this.Type == 0 && c.managerRating == 0) || (this.Type == 2 && c.otherRating == 0) || (this.Type == 1 && c.employeeRating == 0));
              this.item = this.KPIRatings[this.viewSkill]
              },
            (error) => {
              this.error = error;
            }
          );
      
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/performance/RatingModal.vue